import * as React from "react";
import { BrManageContentButton } from "@bloomreach/react-sdk";
import { WebPage } from "@grandvisionhq/analytics";
import { monetate } from "@grandvisionhq/svc-monetate";
import { CmsSeo } from "../../containers/Seo/containers/Seo/Seo.js";
import { CmsPageLayout } from "../../layouts/layouts/Page.js";
import { CmsComponentSlot } from "../../containers/Slot/containers/Slot/Slot.js";
import { useBrPageContext, useBrComponentContext } from "../../context/context/context.js";
import CmsBlogLayout from "../../layouts/layouts/Blog.js";
import CmsContentLayout from "../../layouts/layouts/Content.js";
import { getPageSeo } from "../../utils/utils/get-page-seo.js";
import { useBloomreachPageName } from "../../hooks/hooks/use-bloomreach-page-name.js";
const isBlogArticle = (content) => content.type === "blogArticle";
const ContentPageType = () => {
  const page = useBrPageContext();
  const pageSeo = getPageSeo(page);
  const component = useBrComponentContext();
  const { document: documentRef } = component?.getModels() ?? {};
  const pageName = useBloomreachPageName();
  const document = page?.getContent(documentRef);
  const content = document?.getData();
  React.useEffect(() => {
    monetate().commitMonetateEvent("other_page");
  }, []);
  if (!content) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(React.Fragment, null, document && /* @__PURE__ */ React.createElement(BrManageContentButton, { content: document }), isBlogArticle(content) ? /* @__PURE__ */ React.createElement(CmsBlogLayout, { content }) : /* @__PURE__ */ React.createElement(CmsContentLayout, { content, pageName: pageName || "", hasBreadcrumbs: true }), pageSeo && content && /* @__PURE__ */ React.createElement(
    WebPage,
    {
      pageType: "Information",
      url: pageSeo.canonicalUrl,
      name: content.title,
      description: content.summary
    }
  ));
};
const CmsContentPage = (props) => {
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CmsSeo, null), /* @__PURE__ */ React.createElement(CmsPageLayout, { ...props }, /* @__PURE__ */ React.createElement(CmsComponentSlot, { path: "main/content" }, /* @__PURE__ */ React.createElement(ContentPageType, null))));
};
export {
  CmsContentPage as default
};
//# sourceMappingURL=content.js.map
